export function getDropdownOptionState(
	isSelected: boolean,
	isHighlighted: boolean,
) {
	return isHighlighted
		? isSelected
			? 'highlighted-selected'
			: 'highlighted'
		: isSelected
		? 'selected'
		: 'default';
}
